'use client';

import { PageMain } from '@/app/(app)/page-main';
import {
  ServicePlanTemplateProvider,
  useServicePlanTemplateCtx,
} from '@/app/(app)/settings/service_plans/[id]/provider';
import { ServicePlanTemplateDetails } from '@/app/(app)/settings/service_plans/[id]/tab-details';
import { ServicePlanTemplateServiceTypes } from '@/app/(app)/settings/service_plans/[id]/tab-service-types';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { useLocationParam } from '@/lib/router';

export function ServicePlanPage() {
  const id = useLocationParam('id');
  return (
    <ServicePlanTemplateProvider id={id}>
      <PageContent />
    </ServicePlanTemplateProvider>
  );
}

function PageContent() {
  const { servicePlanTemplate, tab, setTab } = useServicePlanTemplateCtx();

  return (
    <PageMain
      title={servicePlanTemplate.name}
      breadcrumbs={[{ label: 'Subscriptions', href: '/settings/service_plans' }]}
    >
      <div className='mx-auto w-full max-w-2xl space-y-2'>
        <Header />
        <Tabs value={tab} onValueChange={(value) => setTab(value as typeof tab)}>
          <TabsList className='mt-2 mb-2 grid grid-cols-2'>
            <TabsTrigger value='details' className='w-36'>
              Details
            </TabsTrigger>
            <TabsTrigger value='service-types'>Service Types</TabsTrigger>
          </TabsList>
          <TabsContent value='details'>
            <ServicePlanTemplateDetails />
          </TabsContent>
          <TabsContent value='service-types'>
            <ServicePlanTemplateServiceTypes />
          </TabsContent>
        </Tabs>
      </div>
    </PageMain>
  );
}

function Header() {
  const { servicePlanTemplate } = useServicePlanTemplateCtx();

  return (
    <div className='space-y-0.5'>
      <h2 className='text-heading-xl'>{servicePlanTemplate.name}</h2>
      <div className='text-sm text-muted-foreground'>{servicePlanTemplate.description || 'No description'}</div>
    </div>
  );
}
